import { render, staticRenderFns } from "./FullscreenPoster.vue?vue&type=template&id=29b7cdfe&scoped=true"
import script from "./FullscreenPoster.vue?vue&type=script&lang=js"
export * from "./FullscreenPoster.vue?vue&type=script&lang=js"
import style0 from "./FullscreenPoster.vue?vue&type=style&index=0&id=29b7cdfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b7cdfe",
  null
  
)

export default component.exports